// src/pages/DecksPage.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getDecks, getFlashcardsByDeck } from "../utils/apiHelper";
import TextCard from "../components/Flashcards/TextCard";

const DecksPage = () => {
  const [decks, setDecks] = useState([]);
  const [selectedDeck, setSelectedDeck] = useState("");
  const [flashcards, setFlashcards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDecks = async () => {
      try {
        const data = await getDecks();
        setDecks(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("❌ Error fetching decks:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchDecks();
  }, []);

  const handleSelectDeck = async (deckName) => {
    setSelectedDeck(deckName);
    try {
      const cards = await getFlashcardsByDeck(deckName);
      setFlashcards(Array.isArray(cards) ? cards : []);
    } catch (err) {
      console.error("❌ Error fetching flashcards:", err);
      setFlashcards([]);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64 text-gray-600 text-lg">
        ⏳ Loading decks...
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto p-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-center mb-6">
        <h2 className="text-3xl font-bold text-gray-800 mb-3 sm:mb-0">
          📚 Choose a Deck
        </h2>
        <Link
          to="/create-flashcards"
          className="bg-gradient-to-r from-emerald-500 to-teal-500 text-white font-semibold px-5 py-2 rounded-lg shadow-md hover:scale-105 transform transition duration-200"
        >
          ➕ Add New Cards
        </Link>
      </div>

      {/* Deck Buttons */}
      <div className="flex flex-wrap gap-3 mb-8">
        {decks.length > 0 ? (
          decks.map((deck, i) => (
            <button
              key={i}
              onClick={() => handleSelectDeck(deck)}
              className={`px-5 py-2 rounded-xl font-semibold text-white shadow-md transition transform hover:scale-105 ${
                selectedDeck === deck
                  ? "bg-gradient-to-r from-green-500 to-emerald-500"
                  : "bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-cyan-600 hover:to-blue-600"
              }`}
            >
              {deck}
            </button>
          ))
        ) : (
          <p className="text-red-600 font-medium">⚠️ No decks found.</p>
        )}
      </div>

      {/* Flashcards Section */}
      {selectedDeck && (
        <div>
          <h3 className="text-2xl font-semibold text-gray-700 mb-4">
            📘 Flashcards in{" "}
            <span className="text-blue-600">{selectedDeck}</span>
          </h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {flashcards && flashcards.length > 0 ? (
              flashcards.map((card) => (
                <TextCard
                  key={card._id}
                  question={card.question}
                  answer={card.answer}
                />
              ))
            ) : (
              <p className="text-gray-500 col-span-full">
                ⚠️ No flashcards found in this deck yet.
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DecksPage;
